import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { EnvironmentType } from './environments/environment.interface';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

if (environment.environmentType === EnvironmentType.PRODUCTION) {
  (console.log, (console.debug = () => {}));
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
